<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="vm.isDesktop ? 'background-alternative' : 'background'"
    [themeFlush]="vm.isDesktop"
  >
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [lg]="2" />
        <dgx-components-grid-column
          [dgxTheme]="'background'"
          [lg]="8"
          [ngClass]="{
            'protection-details-page__content--desktop': vm.isDesktop
          }"
          [xs]="12"
        >
          <dgx-components-grid-row>
            <dgx-components-grid-column [md]="12">
              <dgx-components-grid-column [xs]="12">
                <us-registration-promotion-banner
                  *ngIf="vm.hasDiscountPrice && vm.discountContent"
                  class="m-4"
                >
                  <p class="typog-h5">{{ vm.discountContent.banner }}</p>
                  <dgx-components-icon
                    [icon]="'gift'"
                    [size]="'lg'"
                    class="ml-2"
                  />
                </us-registration-promotion-banner>

                <h1 class="protection-details-page__title">
                  {{ vm.cmsData.protectionDetailsPageTitle }}
                </h1>
              </dgx-components-grid-column>
            </dgx-components-grid-column>
          </dgx-components-grid-row>

          <dgx-components-grid-row>
            <dgx-components-grid-column [md]="12">
              <dgx-components-grid-column [xs]="12">
                <dgx-components-rich-text
                  [content]="vm.cmsData.protectionDetailsBannerContent"
                  class="protection-details-page__subtitle my-6"
                />
              </dgx-components-grid-column>
            </dgx-components-grid-column>
          </dgx-components-grid-row>

          <dgx-components-grid-row class="protection-details__accordion pt-5">
            <dgx-components-grid-column>
              <us-registration-protection-benefits-accordion-wib
                [isDesktop]="vm.isDesktop"
                [panels]="vm.cmsData.accordionPanels"
              />
              <us-registration-warranty-note-panel [spacingClass]="'mt-5'" />
            </dgx-components-grid-column>
          </dgx-components-grid-row>

          <div *ngIf="vm.annualPlansEnabled; else monthlySubscription">
            <ng-container *ngIf="vm.quoteHasAnnualPayment">
              <!-- Annual Plan Enabled -->
              <dgx-components-grid-row>
                <dgx-components-grid-column>
                  <dgx-components-panel
                    [border]="true"
                    [rounded]="'lg'"
                    [spacing]="'sm'"
                    [variant]="'dg-primary-alternative-light'"
                    class="pt-4 mb-5"
                  >
                    <us-registration-terms-and-conditions
                      [termsAndConditions]="
                        vm.cmsData.protectionDetailsTermsAndConditions
                      "
                      class="protection-details-page__terms-and-conditions"
                    />
                  </dgx-components-panel>
                </dgx-components-grid-column>
              </dgx-components-grid-row>

              <p class="protection-details-page__choose-payment-method py-3">
                {{ 'PROTECTION_DETAILS_CHOOSE_PAYMENT_METHOD' | translate }}
              </p>
              <dgx-components-grid-row>
                <dgx-components-grid-column
                  *ngFor="let item of vm.protectionDetailsPaymentOptions"
                  [md]="6"
                  class="protection-details-page__purchase-price-option-column"
                >
                  <us-registration-protection-details-purchase-price-option-wib
                    (buttonClicked)="cs.handlePaymentOptionAction($event)"
                    [badgeText]="
                      item.paymentFrequency === 'monthly'
                        ? ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY'
                          | translate)
                        : ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY'
                          | translate)
                    "
                    [buttonLoading]="vm.ctaUpsellLoading"
                    [buttonText]="
                      'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA'
                        | translate
                          : {
                              monthlyOrAnnual:
                                item | registeredItemMonthlyOrAnnuallyLabel
                            }
                    "
                    [disclaimer]="
                      'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_DISCLAIMER'
                        | translate
                    "
                    [discountedPrice]="
                      item.paymentFrequency === 'monthly'
                        ? (vm.subscriptionDiscountPrice | currencyFormat)
                        : (vm.prepayPrice | currencyFormat)
                    "
                    [hasDiscountPrice]="vm.hasDiscountPrice"
                    [newMessage]="'PROTECTION_DETAILS_NEW_MESSAGE' | translate"
                    [originalPrice]="
                      (item.paymentFrequency === 'monthly'
                        ? vm.subscriptionPrice
                        : vm.prepayPrice
                      ) | currencyFormat
                    "
                    [paymentFrequency]="item.paymentFrequency"
                    [subscription]="vm.discountContent?.subscription"
                    [subtitle]="
                      item.paymentFrequency === 'monthly'
                        ? ('PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY'
                          | translate)
                        : ('PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL'
                          | translate)
                    "
                  />
                </dgx-components-grid-column>
              </dgx-components-grid-row>
              <dgx-components-grid-row class="mt-3">
                <dgx-components-grid-column [md]="12">
                  <div class="protection-details__register-only-cta-container">
                    <dgx-components-button-text
                      (clicked)="cs.triggerRegistrationUpsellModal()"
                      [dgxGaClick]="{
                        pagename: 'protection-details',
                        applianceName: vm.applianceType,
                        brand: vm.merchandiseBrand,
                        eventCategory: 'applianceCover',
                        eventAction: 'coverType',
                        eventLabel: 'Register only'
                      }"
                      [underline]="true"
                      [underlineNeutral]="true"
                      class="mt-3"
                    >
                      {{
                        'PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA'
                          | translate
                      }}
                    </dgx-components-button-text>
                  </div>
                </dgx-components-grid-column>
              </dgx-components-grid-row>

              <dgx-components-grid-row>
                <dgx-components-grid-column [md]="12">
                  <us-registration-protection-details-accordion-panel-wib
                    [panels]="vm.cmsData.accordionCancelPanels"
                  />
                </dgx-components-grid-column>
              </dgx-components-grid-row>
            </ng-container>
          </div>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <!-- Monthly Subscription-->

  <ng-template #monthlySubscription>
    <dgx-components-grid-row>
      <dgx-components-grid-column [md]="6">
        <dgx-components-grid-column>
          <dgx-components-panel
            [border]="false"
            [rounded]="'lg'"
            [spacing]="'sm'"
            [variant]="'dg-primary-alternative-light'"
            class="pt-4"
          >
            <us-registration-terms-and-conditions
              [termsAndConditions]="
                vm.cmsData.protectionDetailsTermsAndConditions
              "
              class="protection-details-page__terms-and-conditions"
            />
          </dgx-components-panel>
        </dgx-components-grid-column>
      </dgx-components-grid-column>

      <dgx-components-grid-column [md]="6">
        <dgx-components-grid-column>
          <us-registration-protection-details-quote-offer-wib
            [hasDiscountPrice]="vm.hasDiscountPrice"
            [quoteBrand]="vm.merchandiseBrand"
            [quoteDiscountedPrice]="vm.subscriptionDiscountPrice"
            [quoteOriginalPrice]="vm.subscriptionPrice"
            [subscription]="vm.discountContent?.subscription"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-column>
    </dgx-components-grid-row>

    <div class="protection-details__ctas-container">
      <div class="protection-details__ctas">
        <dgx-components-button
          (clicked)="cs.continueToCheckout()"
          [dgxGaClick]="{
            pagename: 'protection-details',
            applianceName: vm.applianceType,
            brand: vm.merchandiseBrand,
            eventCategory: 'applianceCover',
            eventAction: 'coverType',
            eventLabel: 'Register with extra coverage'
          }"
          [fill]="true"
          [loading]="vm.ctaUpsellLoading"
          [variant]="'primary'"
          class="my-4 protection-details__cta"
        >
          {{
            'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE'
              | translate
          }}
        </dgx-components-button>
        <dgx-components-button
          (clicked)="cs.triggerRegistrationUpsellModal()"
          [dgxGaClick]="{
            pagename: 'protection-details',
            applianceName: vm.applianceType,
            brand: vm.merchandiseBrand,
            eventCategory: 'applianceCover',
            eventAction: 'coverType',
            eventLabel: 'Register only'
          }"
          [fill]="true"
          [variant]="'secondary'"
          class="protection-details__cta"
        >
          {{
            'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE'
              | translate
          }}
        </dgx-components-button>
      </div>
    </div>
  </ng-template>
</ng-container>

<div [content]="main" editable-area></div>
